"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _forOwn = _interopRequireDefault(require("lodash/forOwn"));

var _mapValues = _interopRequireDefault(require("lodash/mapValues"));

var _assign = _interopRequireDefault(require("lodash/assign"));

var _parseTargetingString = _interopRequireDefault(require("./parseTargetingString"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var transformers = {
  config: {
    settingTransforms: {},
    blacklistedConfigKeys: [],
    termsTransforms: {}
  },
  get: function getTransformers(config) {
    var _this = this;

    (0, _assign.default)(this.config, config); // eslint-disable-next-line no-underscore-dangle

    return (0, _mapValues.default)(this._transformers, function (transformer) {
      return transformer.bind(_this);
    });
  },
  _transformers: {
    ads: function ads() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var ads = {};
      var config = data.config,
          targeting = data.targeting,
          targetingIDL = data.targetingIDL;

      try {
        (0, _assign.default)(ads, JSON.parse(config));
      } catch (e) {// eslint-disable-line
        // no-op
      }

      try {
        ads.targeting = (0, _parseTargetingString.default)(targeting);
      } catch (e) {// eslint-disable-line
        // no-op
      }

      if (targetingIDL) {
        ads.targetingIdl = targetingIDL;
      }

      return ads;
    },
    autoupdate: function autoupdate(data, experimentOverrides, blacklistConfigOverride) {
      var _this2 = this;

      return data.options.split('|').reduce(function (settings, option) {
        var _option$split = option.split('='),
            _option$split2 = _slicedToArray(_option$split, 2),
            key = _option$split2[0],
            originalValue = _option$split2[1];

        var _this2$config = _this2.config,
            blacklistedConfigKeys = _this2$config.blacklistedConfigKeys,
            settingTransforms = _this2$config.settingTransforms; // If config key is blacklisted, and there isn't an override for it, then
        // don't include it in the parsed settings.

        if (blacklistedConfigKeys.includes(key) && !blacklistConfigOverride.includes(key)) {
          return settings;
        } // Override the response key value with the corresponding query parameter override, if
        // present. We need to make the key lower case as the query params are converted to lower
        // case.


        var value = experimentOverrides[key.toLowerCase()] || originalValue;
        var settingTransform = settingTransforms[key]; // eslint-disable-next-line no-param-reassign

        settings[key] = settingTransform ? settingTransform(value) : value;
        return settings;
      }, {});
    },
    unlock: function unlock(data) {
      var unlock;

      try {
        unlock = JSON.parse(data.config);
      } catch (e) {// eslint-disable-line
        // no-op
      }

      return unlock;
    },
    terms: function terms(data) {
      var _this3 = this;

      var transformedTerms = {};

      try {
        var terms = JSON.parse(data.config);
        (0, _forOwn.default)(terms, function (value, key) {
          var termTransform = _this3.config.termsTransforms[key];
          transformedTerms[key] = termTransform ? termTransform(value) : value;
        });
      } catch (e) {// eslint-disable-line
        // no-op
      }

      return transformedTerms;
    }
  }
};
var _default = transformers;
exports.default = _default;